import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46c3d04a")

_pushScopeId("data-v-46c3d04a")
const _hoisted_1 = { class: "OrderProgress" }
const _hoisted_2 = { class: "OrderProgress__container" }
const _hoisted_3 = {
  key: 0,
  class: "OrderProgress__point"
}
const _hoisted_4 = {
  key: 1,
  class: "OrderProgress__scrollable"
}
const _hoisted_5 = {
  key: 2,
  class: "container__actions"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_order_point = _resolveComponent("order-point")!
  const _component_completed_calendar = _resolveComponent("completed-calendar")!
  const _component_completed_ftl_car = _resolveComponent("completed-ftl-car")!
  const _component_completed_services = _resolveComponent("completed-services")!
  const _component_icon_settings_add = _resolveComponent("icon-settings-add")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (Boolean(_ctx.sender))
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_order_point, {
              isFTL: _ctx.isFTL,
              isLTL: _ctx.isLTL,
              point: _ctx.sender,
              onReset: _ctx.emitResetSender,
              blocked: _ctx.blocked
            }, null, 8, ["isFTL", "isLTL", "point", "onReset", "blocked"])
          ]))
        : _createCommentVNode("", true),
      (Boolean(_ctx.sendDate) && (Boolean(_ctx.sendTime) || Boolean(_ctx.sendPeriod)))
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", {
              class: ["scrollable__container scroll", { ftl: _ctx.isFTL, ltl: _ctx.isLTL }]
            }, [
              _createVNode(_component_completed_calendar, {
                "send-date": _ctx.sendDate,
                "send-time": _ctx.sendTime,
                "send-period": _ctx.sendPeriod,
                blocked: _ctx.blocked,
                onReset: _ctx.emitResetCalendar
              }, null, 8, ["send-date", "send-time", "send-period", "blocked", "onReset"]),
              (Boolean(_ctx.FTLcar))
                ? (_openBlock(), _createBlock(_component_completed_ftl_car, {
                    key: 0,
                    car: _ctx.FTLcar,
                    blocked: _ctx.blocked,
                    onReset: _ctx.emitResetFTLCar
                  }, null, 8, ["car", "blocked", "onReset"]))
                : _createCommentVNode("", true),
              (_ctx.isCanShowAdditionalServices)
                ? (_openBlock(), _createBlock(_component_completed_services, {
                    key: 1,
                    "additional-services": _ctx.additionalServices,
                    "additional-services-billing": _ctx.additionalServicesBilling,
                    blocked: _ctx.blocked,
                    onReset: _ctx.emitResetAdditionalServices
                  }, null, 8, ["additional-services", "additional-services-billing", "blocked", "onReset"]))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (
                    Boolean(_ctx.sender) &&
                    Boolean(_ctx.sendDate) &&
                    (Boolean(_ctx.sendTime) || Boolean(_ctx.sendPeriod)) &&
                    !_ctx.blocked
                )
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_icon_settings_add, {
              class: "actions__action",
              onClick: _ctx.emitOpenAdditionalServices
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})